interface Props {
  domains: string[]
  active: string
  onChange: (domain: string) => void
}

export function DomainFilters({ domains, active, onChange }: Props) {
  const all = ['all', ...domains]
  return (
    <div className="filters">
      {all.map((d) => (
        <button
          key={d}
          type="button"
          className={`filter${active === d ? ' on' : ''}`}
          onClick={() => onChange(d)}
        >
          {d === 'all' ? 'All domains' : d}
        </button>
      ))}
    </div>
  )
}
